import { noop } from 'helpers/utils';
import i18n from 'i18n/config';
import { CrossIcon, CircularCrossIcon } from 'styles/assets/icons';
import Box from 'UIKit/Box';
import DeltaButton from 'UIKit/DeltaButton';
import IconButton from 'UIKit/IconButton';

import styles from './phoneVerification.module.scss';

const unablePhoneVerificationText = i18n.t('account:profile.unablePhoneVerification');
const retryText = i18n.t('account:profile.retry');

const ErrorContent = ({
  closeModal,
  retryClick,
}: {
  closeModal: () => void;
  retryClick: () => void;
}) => {
  return (
    <Box className={styles.mainContainer} flex="flex" flexDir="column">
      <Box fullWidth>
        <IconButton
          data-testid="errorScreenClose"
          icon={<CrossIcon />}
          onClick={closeModal}
          onKeyDown={noop}
          className={styles.crossIcon}
        />
      </Box>
      <CircularCrossIcon
        crossColor="var(--negative)"
        circleColor="var(--negative)"
        className={styles.mainIcon}
      />
      <Box className={styles.errorTextContent}>
        <Box
          className={styles.errorHeading}
          fontSize="md5"
          fontType="semi-bold"
          textColor="primary"
        >
          {unablePhoneVerificationText}
        </Box>
      </Box>
      <Box flex="inline" fullWidth gap={16}>
        <DeltaButton
          className={styles.retryButton}
          data-testid="phoneVerificationRetry"
          onClick={retryClick}
        >
          {retryText}
        </DeltaButton>
      </Box>
    </Box>
  );
};

export default ErrorContent;
